import React from 'react';

const AppNavigationWrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <>
            <div className="transition-padding relative mt-4 mr-0 mb-4 ml-4 flex flex-col gap-6 overflow-visible rounded-3xl bg-white pt-8 shadow-md duration-300 ease-in-out sm:my-4 sm:min-h-[calc(100vh-2rem)] sm:rounded-l-3xl sm:rounded-r-none sm:p-4 dark:bg-gray-900">
                {children}
            </div>
        </>
    );
};

export default AppNavigationWrapper;
